import script from "./spaInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./spaInfo.vue?vue&type=script&setup=true&lang=js"

import "./spaInfo.vue?vue&type=style&index=0&id=6e73efb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e73efb0"]])

export default __exports__